/**
 * This source code is quoted from rc-util.
 * homepage: https://github.com/react-component/util
 */
import createChainableTypeChecker from './utils/createChainableTypeChecker';
export default function all() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;
    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(void 0, args);

      if (result != null) {
        error = result;
      }
    });
    return error;
  }

  return createChainableTypeChecker(allPropTypes);
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-core/src/all.js